export default "__VITE_ASSET__CANxtfni__"